// extracted by mini-css-extract-plugin
module.exports = {"modalSettings":"ParserSettings_modalSettings__2Xf2K"};